import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import NewTeam from "../../modals/NewTeam";
import OutOfCredits from "../../modals/OutOfCredits";
import { makeStyles } from'@mui/styles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { grey } from "@mui/material/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 207,
    height: 240,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    border: "1px solid rgba(0, 27, 17, 0.1)",
    borderRadius: 12,
    boxSizing: 'border-box',
  },
  avatarDiv: {
    display: "contents",
  },
  cardMargin: {
    marginBottom: theme.spacing(0.5),
  },
  cardHeader: {
    textAlign: "center",
    padding: "10px",
  },
  cardTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 20,
    color: "#48647F",
    textAlign: "center",
    letterSpacing: 0.15,
  },
  cardSubtitle: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: 0.15,
  },
  cardCat: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 16,
    color: "#001B11",
  },
  cardText: {
    color: "rgba(0, 27, 17, 0.7)",
    fontFamily: "Open Sans",
    margin: theme.spacing(1),
    fontSize: 16,
    fontWeight: 600,
  },
  cardFooter: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    color: "rgba(0, 27, 17, 0.7)",
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 400,
  },
  cardContent: {
    padding: '6px 8px',
  },
}));

const CreateCard = ({ credits }) => {
  const [showOutOfCreditsModal, setShowOutOfCreditsModal] = useState(false);
  const [showCreateTeamModal, setShowCreateTeamModal] = useState(false);
  const [creditsMessage, setCreditsMessage] = useState("");
  const classes = useStyles();

  // This action will toggle a modal on the dashboard page
  const toggleDashboardModal = () => {
    // Check team credits
    if (credits >= 6) {
      setShowCreateTeamModal(!showCreateTeamModal);
    } else {
      setShowOutOfCreditsModal(!showOutOfCreditsModal);
    }
  };

  useEffect(() => {
    if (credits === 0) {
      setCreditsMessage(`You can not create any more teams.`);
    } else if (credits === 1) {
      setCreditsMessage(`You can create ${credits} more team.`);
    } else {
      setCreditsMessage(`You can create ${credits} more teams.`);
    }
  }, [credits]);

  return <>
    {showCreateTeamModal && <NewTeam toggleModal={toggleDashboardModal} />}
    {showOutOfCreditsModal && (
      <OutOfCredits toggleModal={toggleDashboardModal} />
    )}
    <Button
      // className="button button--dashboard_team"
      onClick={toggleDashboardModal}
      aria-label="Create a new team"
    >
      <Grid container direction="column">
        <Card className={classes.root}>
          <CardContent className={classes.cardContent}>
            <Grid container className={classes.cardMargin}>
              <Grid container justifyContent="center">
                <Grid item xs={12} className={classes.avatarDiv}>
                  <AddCircleIcon style={{ color: grey[300], fontSize: 97 }} />
                </Grid>
                <Grid item xs={12} className={classes.cardHeader}>
                  <Typography variant="h5" className={classes.cardTitle} aria-label="Create a new team">
                    Create a New Team
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Button>
  </>;
};

export default CreateCard;

CreateCard.propTypes = {
  credits: PropTypes.number,
};